import { hasIn as _hasIn } from 'lodash-es';

export function hasIn<T>(target: T | null | undefined, property: keyof T): target is T {
	return _hasIn(target, property);
}
